import BaseApiService from './base.api-service';

const URL = 'nerve/rbac';
const ENDPOINTS = {
  GET_ALL_ROLES: `${URL}/roles`,
  CRUD_ROLE: `${URL}/roles`,
  GET_ALL_PERMISSIONS: `${URL}/permissions`,
  GET_PERMISSION: `${URL}/permissions/`,
  GET_ALL_CATEGORIES: `${URL}/categories`,
};

class RolesApiService extends BaseApiService {
  getAllRoles(params) {
    return this.get(ENDPOINTS.GET_ALL_ROLES, params, { authRequired: true });
  }

  getRole(roleId) {
    return this.get(`${ENDPOINTS.CRUD_ROLE}/${roleId}`, { authRequired: true });
  }

  createRole(data) {
    return this.post(ENDPOINTS.CRUD_ROLE, data, { authRequired: true });
  }

  updateRole(roleId, data) {
    return this.patch(`${ENDPOINTS.CRUD_ROLE}/${roleId}`, data, { authRequired: true });
  }

  deleteRole(roleId) {
    return this.delete(`${ENDPOINTS.CRUD_ROLE}/${roleId}`, { authRequired: true });
  }

  getPermissions(data) {
    let params = {};
    if (data) {
      params = {
        ...(data.searchText && { filterBy: { name: data.searchText } }),
        ...(data.categories?.length && { categories: data.categories }),
      };
    }
    const query = new URLSearchParams();
    if (params.categories?.length) {
      query.set('categories', params.categories);
    }
    if (params.filterBy) {
      query.set('filterBy', JSON.stringify(params.filterBy));
    }
    const queryString = query.toString();
    return this.get(`${ENDPOINTS.GET_ALL_PERMISSIONS}${queryString ? `?${queryString}` : ''}`, { authRequired: true });
  }

  getPermission(permissionId) {
    return this.get(`${ENDPOINTS.GET_PERMISSION}/${permissionId}`, { authRequired: true });
  }

  getCategories() {
    return this.get(ENDPOINTS.GET_ALL_CATEGORIES, { authRequired: true });
  }

  getUserPermissions(userId) {
    return this.get(`${URL}/users/${userId}/permissions`, { authRequired: true });
  }

  /**
   * Retrieves detailed active permissions for a user.
   */
  /**
   * Retrieves detailed active permissions for a user.
   * @param {string} userId
   * @param {Object} options
   * @param {'all'|'API'|'UI'} options.type - filter by permission type. Default is 'all'.
   */
  getUserPermissionsDetailed(userId, type, usage) {
    const params = new URLSearchParams({ type: type || 'all' });
    if (usage !== undefined) {
      params.set('usage', usage);
    }
    return this.get(`${URL}/users/${userId}/permissions/detailed?${params.toString()}`, { authRequired: true });
  }
}

export default new RolesApiService();
